import '../css/activity-settings.css';
export default {
  mounted() {
    console.log('componentMounted', this);
    app.f7.preloader.hide();
  },

  id: 'df207a09ca',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>Notifications settings</div></div></div><div class="page-content activitypage"><div class=block-title>Enable notifications for:</div><div class="list media-list settingslist"><ul><li><a href=# class=item-content><div class=item-inner><div class=item-title-row><div class=item-title>Cancelations</div><label class="toggle toggle-init color-green"><input type=checkbox> <span class=toggle-icon></span></label></div></div></a></li><li><a href=# class=item-content><div class=item-inner><div class=item-title-row><div class=item-title>Reservations</div><label class="toggle toggle-init color-green"><input type=checkbox> <span class=toggle-icon></span></label></div></div></a></li><li><a href=# class=item-content><div class=item-inner><div class=item-title-row><div class=item-title>Messages</div><label class="toggle toggle-init color-green"><input type=checkbox> <span class=toggle-icon></span></label></div></div></a></li></ul></div></div></div><!-- And somewhere in DOM -->';
      return r;
    }(this);
  },

  style: `

`,
  styleScoped: false
};